import axios from 'axios';
import {Env, getApiEnv} from './config';
import {getAppEnv} from "../Services/utils";

export const reqClient = axios.create({
	baseURL: getApiEnv(getAppEnv() as Env),
	headers: { 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json' }
});